import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject
} from '@angular/core';

import { asapScheduler } from 'rxjs';

import { UserAccount } from '@hdms/shared/page-frame/types';
import { EnvironmentService, TokenService } from '@hdms/shared/util-core';

@Component({
  selector: 'shrd-pf-ui-header-user-select',
  templateUrl: './header-user-select.component.html',
  styleUrls: ['./header-user-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserSelectComponent implements OnInit {
  @Input() accounts: UserAccount[];
  @Input() selectedAccountId: string;
  @Input() disabled = false;

  @Output() accountChanged = new EventEmitter<string>();

  csrfToken: string;
  currentUrl: string;
  accountId: string;
  inHostContext: boolean;

  private readonly env = inject(EnvironmentService);
  private readonly tokenService = inject(TokenService);
  private readonly location = inject(Location);
  private readonly cdr = inject(ChangeDetectorRef);

  @ViewChild('selectAccountForm', { read: ElementRef })
  private readonly selectAccountForm: ElementRef<HTMLFormElement>;

  ngOnInit(): void {
    this.inHostContext = !!this.env.hostContext;
  }

  onSelectedAccountChanged(accountId: string): void {
    this.accountChanged.emit(accountId);
    this.inHostContext && this.submitSelectAccountForm(accountId);
  }

  trackById(_index, account: UserAccount): string {
    return account.originId;
  }

  private submitSelectAccountForm(accountId: string): void {
    this.accountId = accountId;
    this.csrfToken = this.tokenService.csrfToken;
    this.currentUrl = this.location.path();
    this.cdr.detectChanges();

    asapScheduler.schedule(() => this.selectAccountForm.nativeElement.submit());
  }
}
